import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { ErrorCardComponent } from './components/error-card/error-card.component';
import { ErrorCardExplicitComponent } from './components/error-card-explicit/error-card-explicit.component';
import { ErrorCardExplicitCloseableComponent } from './components/error-card-explicit-closeable/error-card-explicit-closeable.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule
    ],
    declarations: [
        ErrorCardComponent,
        ErrorCardExplicitComponent,
        ErrorCardExplicitCloseableComponent
    ],
    exports: [
        ErrorCardComponent,
        ErrorCardExplicitComponent,
        ErrorCardExplicitCloseableComponent
    ]
})
export class ErrorsModule { }
